import React, { ReactNode } from 'react';

interface Props {
  number: ReactNode;
  title: string;
  className?: string;
}

const Statistic = (props: Props) => {
  const { number, title, className } = props;
  return (
    <div
      className={`${className} md:mb-0 md:w-1/2 md:flex md:flex-col md:justify-center`}
    >
      <h3 className="text-green-100 text-4xl md:text-5xl">{number}</h3>
      <p className="text-gray-700 text-xl md:text-2xl">{title}</p>
    </div>
  );
};

export default Statistic;
